import {Grid2, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {KeyValuePair} from "../base/KeyValuePair";
import {Order} from "../../types/domain/order";

export interface Props {
    order: Order | undefined;
}

export const OrderFlagsCard: React.FC<Props> = ({order}) => {
    const {t} = useTranslation();
    return (
        <Grid2 container spacing={3}>
            <Grid2 size={12}>
                <KeyValuePair header={t("orders.order_detail_view.flags")}>
                    <Typography>{order?.flags && order.flags.length > 0 ? order.flags?.join(", ") : "-"}</Typography>
                </KeyValuePair>
            </Grid2>
        </Grid2>
    );
};
